<template>
  <div v-if="exam" id="shiyan">
    <div v-if="examType == 1">
      <additi-prepare @toBack="goBack" @toExam="goExam" :subjectid='examData.subjectid' :relationid='examData.relation_id'>
      </additi-prepare>
    </div>
    <div v-else-if='examType == 2'>
      <additi-exam
        :subjectid='examData.subjectid'
        :relationid='examData.relation_id'
        autoinit="true">
        <exp-header slot="header" @rightClick="submmitExam" @leftClick="goBack" :titlelabel='examData.name || examData.exam_name' buttonlabel="提交">
          <time-progress @timeOut="timeOutSubmmit" :totaltime='examData.examTime' slot="header-bottom"></time-progress>
        </exp-header>
      </additi-exam>
    </div>

    <div v-else-if="examType == 3">
      <additi-practice :subjectid='examData.subjectid'
                       :relationid='examData.relation_id'
                       @stepTitleChange='setTitle'
                       autoinit="true">
        <exp-header slot="header" :titlelabel='examData.name' buttonlabel="进入考试"
                    @leftClick="goBack"
                    @rightClick='examType = 2'>
          <div style='color:white' slot="header-bottom">{{ stepTitle }}</div>
        </exp-header>
      </additi-practice>
    </div>
  </div>
</template>
<script>
  export default {
    name:'entExam',
    data(){
      return {
        examId:'',//考试Id
        AppConfig:{
          // BASE_URL: 'http://addphys.nobook.cc/v1/',
          BASE_URL: 'https://imgcdn.nobook.com/exam/resource/addicomponents/v11/',
          // DATA_BASE_URL: 'http://exam-app.noteach.com.cn/api', // 数据请求相关
          DATA_BASE_URL: `${window.__nb_api_host || 'https://exam-app.nobook.com'}/api`,  // 数据请求相关
          TOKEN: '',
          PID: 'EXAMWEBWLuC5K',
          UID: '',
          LOGIN_BASE_URL: window.__nb_passport_api,
          DATAURL: {
            COURSE_INFO: 'jiashicoursere/info',  // 打开一个实验，获取实验信息
            SAVE_COURSE: 'jiashicoursere/saveCourse', // 保存考试数据
            CHART_DATA: 'count/countChartData', // 实验分数图表数据
            TEST_LIST: 'test/list', // 获取分数测试列表
            TEST_INFO: 'test/info', // 测试详情
            ACCOUNT_INFO: 'account/info', // 用户基本信息
            SAVE_COURSE_TECH: 'teachermanager/exercise/saveExam', // 教师发布的保存接口
            GET_VIP: 'package/getVipByPackageId' // 获取vip信息
          }
        },
        examData:{},
        examType:1,
        stepTitle:'',
        exam:false,
        _TYPE:''
      }
    },
    methods:{
      //父组件点击实验
      //重新测验和学生考试进入$type为2直接进入考试模式,学生考试进入$type为3更换提交接口，实验库进入$type为空
      examClick($data,$type){
        this.showHader(2);

        $('url-config')[0].setConfig(this.AppConfig);
        this.examData = $data;
        this.AppConfig.TOKEN = this.GLOBAL.userLoginInfo.token;
        this.examData.examTime =this.examData.examTime?this.examData.examTime:600000;
        this.exam = true;
        if($type == 2){
          this.examType = 2;
        }else if($type == 3){
          this.examType = 2;
          this._TYPE = $type
        }
      },
      //      头部显示隐藏
      showHader($type){
        if($type == 1){
          $('.db-header ').show();
        }else{
          $('.db-header ').hide();
          $('.prep-content ').css('overflow','hidden');
        }
      },
      //      实验返回
      goBack(){
        let that = this;
        this.$confirm('您确认退出吗', '确认退出', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$emit('goBack');
          that.showHader(1);
          that.exam = false;
          $('#shiyan').css('overflow','auto');
          $('body').css('overflow','auto');
        });
      },
      goExam($data){
        this.examType = $data.detail.isexam?2:3
      },
      //      实验提交
      submmitExam($data){
        let that =this;
        let examdom = $('additi-exam')[0];
        let timedom = $('time-progress')[0];
        let usetime = Math.floor(timedom.getUsetime() / 1000);
        let _msg = this.examType ==2?'您要提交并查看成绩吗?':'您确认退出返回实验库吗？';
        let _title = this.examType ==2?'确认提交':'确认退出';
        this.$confirm(_msg, _title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(this._TYPE == 3){
            let id = this.examData.id;
            examdom.webSubmitData(usetime,id).then((dat) => {
              // debugger;
              if (dat.code == 200 || dat.code == 0) {
                //this.goBack();
                // this.$emit('goBack');
                this.$router.push({ path: '/studentexamdetails',
                  query: { plan: dat.data.info.id,name:that.examData.name,title:that.examData.exam_name}});
                $('#shiyan').css('overflow','auto');
                $('body').css('overflow','auto');
                this.showHader(1);
                this.exam = false;
              } else {
                alert(dat.msg);
              }
            });
          }else{
            examdom.submitData(usetime).then((dat) => {
              if (dat.code == 200 || dat.code == 0) {
                if(this.examType == 2){
                  this.showHader(1);
                  this.exam = false;
                  $('body').css('overflow','auto');
                  this.$router.push({ path: '/storetestrecord', query: { plan: 1,type:2,goback:1}})
                }else{
                  // this.goBack();
                  this.$emit('goBack');
                  $('#shiyan').css('overflow','auto');
                  $('body').css('overflow','auto');
                  this.showHader(1);
                  this.exam = false;
                }
                window.location.reload();
              } else {
                alert(dat.msg);
              }
            })
          }
        });
      },
      setTitle($data){
        this.stepTitle = $data.detail;
      },
      timeOutSubmmit(){
        if(this._TYPE == 3){
          let id = this.examData.id;
          examdom.webSubmitData(usetime,id).then((dat) => {
            if (dat.code == 200 || dat.code == 0) {
              //this.goBack();
              this.$emit('goBack');
              $('#shiyan').css('overflow','auto');
              $('body').css('overflow','auto');
              this.showHader(1);
              this.exam = false;
            } else {
              alert(dat.msg);
            }
          });
        }else{
          let examdom = $('additi-exam')[0];
          let timedom = $('time-progress')[0];
          let usetime = Math.floor(timedom.getUsetime() / 1000);
          examdom.submitData(usetime).then((dat) => {
            if (dat.code == 200 || dat.code == 0) {
              if(this.examType == 2){
                this.showHader(1);
                this.exam = false;
                $('body').css('overflow','auto');
                this.$router.push({ path: '/storetestrecord', query: { plan: 1,type:2}})
              }else{
                // this.goBack();
                this.$emit('goBack');
                $('#shiyan').css('overflow','auto');
                $('body').css('overflow','auto');
                this.showHader(1);
                this.exam = false;
              }
            } else {
              alert(dat.msg);
            }
          })
        }
      }
    },
    mounted(){
      this.AppConfig.TOKEN = this.GLOBAL.userLoginInfo.token;
      this.AppConfig.UID = this.GLOBAL.userLoginInfo.userid;
    }
  }
</script>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/entExam.vue